import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loading-animation',
    templateUrl: './loading-animation.html',
    styleUrls: ['./loading-animation.css'],
    encapsulation: ViewEncapsulation.None
})
export class LoadingAnimationComponent {}


// WEBPACK FOOTER //
// ./web/static/components/loading-animation/loading-animation.ts